import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { TextAlign } from "../../../../../../requests/templates/types";

type StyledTdProps = {
  textColor: string;
  textAlign: TextAlign;
};

// eslint-disable-next-line
export const StyledTd = styled.td<StyledTdProps>`
  color: ${(props) => props.textColor};
  text-align: ${(props) => String(props.textAlign).toLowerCase()};
`;

export const StyledDivTd = styled.div<StyledTdProps>`
  display: table-cell;
  align-self: center;
  vertical-align: middle;
  color: ${(props) => props.textColor};
  text-align: ${(props) => String(props.textAlign).toLowerCase()};
`;

export const getControlsCellCss = (isVisible: boolean) => css`
  visibility: ${isVisible ? "visible" : "hidden"};
  display: table-cell;
`;
